


































































































































































































































































































































































































import Vue from 'vue';
import JSConfetti from 'js-confetti';
import EventBus from '@/eventBus.js';
import Bugsnag from '@bugsnag/js';
import i18n from 'vue-i18n';
import { isEmail, isStrongPassword } from 'validator';
import { first, get } from 'lodash';
import axios from 'axios';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoCardTicket from '@/components/Molecules/co-card-ticket/CoCardTicket.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import { ca } from 'date-fns/locale';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoMyTicket from '@/components/Organisms/co-my-ticket/CoMyTicket.vue';
import CoForm from '@/components/Molecules/co-form/CoForm.vue';
import CoCardBillingAddress from '@/components/Organisms/co-card-billing-address/CoCardBillingAddress.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
Vue.prototype.$isMobile = window && window.innerWidth <= 992;
const jsConfetti = new JSConfetti();

interface EventTicket {
    ID?: string;
    Name: string;
    Description?: string;
    PriceInCents: number;
    TaxRateID?: string;
    Limit: number;
    CreatedAt?: number;
    UpdatedAt?: number;
    CancellationNotice?: number;
    CancellationFee?: number;
    TermsAndConditions?: string;
    Deleted?: boolean;
    SoldOut?: boolean;
}

interface GuestTicketCheckoutRequest {
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    Phone?: string;
    Company?: string;
    AdditionalInfo?: string;
    Address: string;
    PostalCode: string;
    City: string;
    Country: string;
    VATNumber?: string;
    EventID: string;
    EventTicketTypeID: string;
}

export default {
    name: 'CoEventTicketCheckoutAsGuest',
    components: {
        CoText,
        CoCardTicket,
        CoModal,
        CoHeadline,
        CoButton,
        CoCheckbox,
        CoLoadingIndicator,
        CoMyTicket,
        CoForm,
        CoCardBillingAddress,
        CoCard,
        CoLink,
        CoFormGroup,
        CoInput,
        CoRoundButton,
    },
    props: {
        eventName: {
            type: String,
            required: false,
            default: '',
        },
        eventID: {
            type: String,
            required: true,
        },
        eventSlug: {
            type: String,
            required: true,
        },
        tickets: {
            type: Array as () => EventTicket[],
            required: false,
            default: () => [] as EventTicket[],
        },
        taxRates: {
            type: Array as () => Array<any> | null,
            default: () => [],
        },
        currency: {
            type: String,
            required: false,
            default: '',
        },
        ticketPurchaseState: {
            type: String,
            required: false,
            default: 'buy',
            validator(value: string) {
                return ['buy', 'success', ''].includes(value);
            },
        },
    },
    data() {
        return {
            step: 1, // 1 - select tickets, 2 - billing address, 3 - Checkout view
            loading: false,
            selectedTicket: null as EventTicket | null,
            acceptTermsAndConditions: false,

            loadingMyTicket: false,
            myTicket: null,

            checkoutdata: {} as GuestTicketCheckoutRequest,
        };
    },
    watch: {
        step(val) {
            if (val === 2) {
                // document.querySelector('#altcha').configure({ auto: 'onload', delay: 300 });
                // document.querySelector('#altcha').addEventListener('statechange', (ev) => {
                //     // state can be: unverified, verifying, verified, error
                //     // console.log('state:', ev.detail.state);
                //     if (get(ev, 'detail.state', '') === 'verified') {
                //         this.captchaVerified = true;
                //         // debugger;
                //         // payload contains base64 encoded data for the server
                //         // console.log('payload:', ev.detail.payload);
                //         this.captchaPayload = ev.detail.payload;
                //     }
                // });
            }
        },
    },
    computed: {
        canICheckout() {
            if (
                !this.selectedTicket ||
                (this.selectedTicket && this.selectedTicket.TermsAndConditions && !this.acceptTermsAndConditions)
            ) {
                return false;
            }

            if (
                !this.checkoutdata.FirstName ||
                !this.checkoutdata.FirstName.trim() ||
                !this.checkoutdata.LastName ||
                !this.checkoutdata.LastName.trim() ||
                !this.checkoutdata.Email ||
                !this.checkoutdata.Email.trim() ||
                !this.checkoutdata.Password ||
                !this.checkoutdata.Password.trim()
            ) {
                return false;
            }
            return true;
        },

        total() {
            if (!this.selectedTicket) {
                return `0,00 ${this.currencyChar}`;
            }
            const priceInCents = this.selectedTicket.PriceInCents ? this.selectedTicket.PriceInCents : 0;

            if (this.selectedTicket.TaxRateID) {
                const taxRate = this.taxRates.find((taxRate) => taxRate.ID === this.selectedTicket.TaxRateID);
                if (taxRate && !taxRate.Inclusive) {
                    const percentage = taxRate.Percentage ? taxRate.Percentage : 0;
                    const price = priceInCents * (1 + percentage / 100);
                    let vatStr = (price / 100).toFixed(2);
                    vatStr = vatStr.replace('.', ',');

                    return `(${percentage}%) ${vatStr} ${this.currencyChar}`;
                }
            }
            let priceStr = (priceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');
            return `${priceStr} ${this.currencyChar}`;
        },
        vat() {
            if (!this.selectedTicket) {
                return `0,00 ${this.currencyChar}`;
            }

            if (this.selectedTicket.TaxRateID) {
                const taxRate = this.taxRates.find((taxRate) => taxRate.ID === this.selectedTicket.TaxRateID);
                if (taxRate) {
                    const priceInCents = this.selectedTicket.PriceInCents ? this.selectedTicket.PriceInCents : 0;

                    const percentage = taxRate.Percentage ? taxRate.Percentage : 0;
                    const price = priceInCents * (percentage / 100);
                    let vatStr = (price / 100).toFixed(2);
                    vatStr = vatStr.replace('.', ',');

                    return `(${percentage}%) ${vatStr} ${this.currencyChar}`;
                }
            }

            return `0,00 ${this.currencyChar}`;
        },
        netPrice() {
            if (!this.selectedTicket) {
                return `0,00 ${this.currencyChar}`;
            }

            if (this.selectedTicket.TaxRateID) {
                const taxRate = this.taxRates.find((taxRate) => taxRate.ID === this.selectedTicket.TaxRateID);
                if (taxRate && taxRate.Inclusive) {
                    const price =
                        this.selectedTicket.PriceInCents -
                        this.selectedTicket.PriceInCents * (taxRate.Percentage / 100);
                    let priceStr = (price / 100).toFixed(2);
                    priceStr = priceStr.replace('.', ',');
                    return `${priceStr} ${this.currencyChar}`;
                }
            }

            let priceStr = (this.selectedTicket.PriceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');

            return `${priceStr} ${this.currencyChar}`;
        },

        subtotalTicketPrice() {
            if (!this.selectedTicket) {
                return `0,00 ${this.currencyChar}`;
            }

            let priceStr = (this.selectedTicket.PriceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');

            return `${priceStr} ${this.currencyChar}`;
        },
        ticketPrice() {
            if (!this.selectedTicket) {
                return `0,00 ${this.currencyChar}`;
            }

            let priceStr = (this.selectedTicket.PriceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');

            return `${priceStr} ${this.currencyChar}`;
        },

        currencyChar() {
            if (!this.currency) {
                return '€';
            }

            const currency = this.currency.toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        listTickets() {
            // Filter out deleted tickets and sort by price in ascending order also filter sold out tickets as last
            return this.tickets
                .filter((ticket) => !ticket.Deleted)
                .sort((a, b) => a.PriceInCents - b.PriceInCents)
                .sort((a, b) => (a.SoldOut ? 1 : 0) - (b.SoldOut ? 1 : 0));
        },
    },
    mounted() {},
    methods: {
        validateEmail(value) {
            if (!value) {
                return false;
            }
            return isEmail(value);
        },

        validatePassword(value) {
            if (!value) {
                return false;
            }
        },
        next() {
            this.step = 2;
        },
        showEventDetails() {
            // replace url
            this.$router.replace(`/event/${this.eventSlug}`);

            // hide modal
            this.$refs['co-event-ticket-checkout'].hide();
        },
        hideModal() {
            this.$refs['co-event-ticket-checkout'].hide();
            this.selectedTicket = null;
        },
        openModal() {
            this.$refs['co-event-ticket-checkout'].show();
        },
        selectTicket(ticket: EventTicket) {
            if (this.loading) {
                return;
            }
            if (!ticket.PriceInCents) {
                ticket.PriceInCents = 0;
            }

            this.selectedTicket = ticket;
        },
        createOrder() {
            this.loading = true;

            const successURL = `${window.location.origin}/event/${this.eventSlug}?tp=success&ticket_type_id=${this.selectedTicket?.ID}`;
            const cancelURL = `${window.location.origin}/event/${this.eventSlug}?tp=cancel&ticket_type_id=${this.selectedTicket?.ID}`;

            let req = {
                ticket_type_id: this.selectedTicket?.ID,
                event_id: this.eventID,
                success_url: successURL,
                cancel_url: cancelURL,
                firstName: this.checkoutdata.FirstName,
                lastName: this.checkoutdata.LastName,
                email: this.checkoutdata.Email,
                password: this.checkoutdata.Password,
                phone: this.checkoutdata.Phone,
                company: this.checkoutdata.Company,
                additionalInfo: this.checkoutdata.AdditionalInfo,
                address: this.checkoutdata.Address,
                postalCode: this.checkoutdata.PostalCode,
                city: this.checkoutdata.City,
                country: this.checkoutdata.Country,
                vatNumber: this.checkoutdata.VATNumber,
            };

            axios({
                method: 'POST',
                url: '/public/event/ticket',
                data: req,
            })
                .then((response) => {
                    // get token
                    const token = get(response, 'data.Token', '');
                    if (token) {
                        localStorage.setItem('_authtoken', token);
                        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                        this.$store.dispatch('getMe', null).then(() => {
                            // redirect to payment page
                            const paymentURL = get(response, 'data.ticket.PaymentURL', '');
                            if (paymentURL) {
                                window.location.href = paymentURL;
                                this.loading = false;
                            } else if (get(response, 'data.ticket.Status', null) === 2) {
                                this.myTicket = get(response, 'data.ticket', null);
                                jsConfetti.addConfetti();
                                this.ticketPurchaseState = 'success';
                                window.location.href = successURL;
                                this.loading = false;
                            } else {
                                console.error('No payment URL found');
                            }
                        });
                    } else {
                        // redirect to payment page
                        const paymentURL = get(response, 'data.ticket.PaymentURL', '');
                        if (paymentURL) {
                            window.location.href = paymentURL;
                            this.loading = false;
                        } else if (get(response, 'data.ticket.Status', null) === 2) {
                            this.myTicket = get(response, 'data.ticket', null);
                            jsConfetti.addConfetti();
                            this.ticketPurchaseState = 'success';
                            window.location.href = successURL;
                            this.loading = false;
                        } else {
                            console.error('No payment URL found');
                        }
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                    Bugsnag.notify(error);
                    EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                })
                .finally(() => {});
        },
    },
};
